import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useMemo } from 'react';
import { BKJCheckbox } from '../BKJCheckbox/BKJCheckbox.js';
import { ListItemWrapper } from '../BKJListItem/BKJListItem.styled.js';
import { ListItemText, SubLabel } from '../common/ListItemBaseCSS/index.js';
export const BKJCheckboxListItem = forwardRef((props, ref) => {
    const { onChange, name, subLabel, label, className, disabled = false, isTargeted = false, selected, value, listItemVariant = 'LeftAlignAlternatingBackgroundColor', checkboxVariant = 'GreenSolid', ...rest } = props;
    const checked = useMemo(() => {
        if (Array.isArray(selected)) {
            return selected?.some((str) => String(str) === String(value));
        }
        else {
            return false;
        }
    }, [selected, value]);
    const handleClick = useCallback((event) => {
        event.preventDefault && event.preventDefault();
        if (onChange)
            onChange({ ...event, target: { ...event.target, checked, name, value, label } });
    }, [checked, label, name, onChange, value]);
    return (_jsxs(ListItemWrapper, { ...rest, variant: listItemVariant, role: "listbox", onClick: handleClick, className: className, checked: checked, disabled: disabled, isTargeted: isTargeted, ref: ref, children: [_jsx(BKJCheckbox, { variant: checkboxVariant, value: checked, disabled: disabled, readOnly: true }), _jsx(ListItemText, { children: label }), subLabel && _jsx(SubLabel, { children: subLabel })] }));
});
//# sourceMappingURL=BKJCheckboxListItem.js.map